/**
 * Copyright (c) Mik BRY
 * mik@mikbry.com
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useSelector } from "@ziiircom/messenger/src/utils/store";
import Interface from '../../interface';
import Theme from '../../Theme';

const FileInputStyled = Interface.styled('input')`
  display: none;
`;

const FileInputLabelStyled = Interface.styled('label')`
  font-size: 1.25em;
  font-weight: 700;
  color: ${(props) => props.theme.palette.secondary};
  background-color: ${(props) => props.theme.palette.primary};
  margin-top: 8px;
  margin-left: 48px;
  padding: 8px;
  display: block;
  width: fit-content;
  border-radius: 8px;
`;
FileInputLabelStyled.defaultProps = {
  theme: Theme,
};

const e = Interface.createElement;
const FileInput = ({ options = {}, onAction = () => {}, showTemplateActions = true }) => {
  const [fileInputConfig] = useSelector((state) => [
    state.messenger.fileInput || {}
  ]);

  const uploadFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return fetch(fileInputConfig?.uploadPath, {
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(data => data.success ? data.path : data.error ?? 'Upload error')
    ;
  }

  const readFile = async (file) => new Promise((resolve) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(file)
  })

  const handleDefaultAction = (event) => {
    const input = event.target;

    const inputFiles = [...input.files];
    const payloads = [];
    inputFiles.forEach(async (inputFile) => {
      payloads.push(fileInputConfig?.uploadPath ? await uploadFile(inputFile) : await readFile(inputFile));
      if (payloads.length === inputFiles.length) {
        onAction('FILE', payloads.length > 1 ? payloads : payloads[0]);
        input.nextElementSibling.style.display = 'none';
      }
    });
  };

  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  // eslint-disable-next-line no-bitwise
  const genSelector = () => [...Array(16)].map(() => c[~~(Math.random() * c.length)]).join('');
  const selector = genSelector();

  return e('div', { className: 'ziiir-message-file-input' }, showTemplateActions ? [
    e(FileInputStyled, { type: 'file', ...options, id: selector, name: selector, onChange: handleDefaultAction }),
    e(FileInputLabelStyled, { for: selector }, options.placeholder ?? 'Upload')
  ] : null);
};

export default FileInput;
